var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-row",class:{'content-row--pull-up': _vm.pullUp, 'content-row--alt': _vm.alt, 'content-row--darken-image': _vm.image && _vm.darkenImage},style:({'background-color': _vm.colour})},[(_vm.image)?_c('img',{staticClass:"content-row__image",attrs:{"src":_vm.image}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }